<template>
  <b-card v-if="$hidderComponent('ats:service', (isService = false))" class="h-100">
    <b-card-title class="mb-4">Entretiens</b-card-title>
    <div class="overflow-auto" style="height: 90%">
      <ul v-if="loaded && interviews.length > 0" class="verti-timeline list-unstyled">
        <li
          v-for="(interview, index) in interviews"
          :key="index"
          :class="{ active: interview.id === actualInterview.id }"
          class="event-list cursor-pointer"
          @click="goToInterview(interview)"
        >
          <div class="event-timeline-dot">
            <i
              :class="{ 'bx-fade-right': interview.id === actualInterview.id }"
              class="bx bx-right-arrow-circle font-size-18"
            ></i>
          </div>
          <div class="media">
            <div class="me-3">
              <h5 class="font-size-14 m-0">
                {{ interview.start | formatDate }}
                <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
            </div>
            <div class="media-body">
              <div>
                Candidat : {{ interview.cvtech.first_name }} {{ interview.cvtech.last_name }} - Recrutement :
                {{ interview.recruitment.job_name }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <h-e-spinner v-if="!loaded"></h-e-spinner>
      <h4 v-if="interviews.length === 0 && loaded" class="text-primary text-center">
        Vous n'avez pas d'entretien aujourd'hui
      </h4>
    </div>
  </b-card>
</template>

<script>
import { APIRequest } from '@/node-sdk'
import moment from 'moment'

export default {
  name: 'interview',

  filters: {
    formatDate(date) {
      return moment(date).format('HH:mm')
    },
  },

  data() {
    return {
      interviews: [],
      loaded: false,
      actualInterview: null,
    }
  },

  mounted() {
    this.getInterviews()
  },

  methods: {
    getInterviews() {
      if (this.$hidderComponent('ats:service', false)) {
        const self = this
        const request = `?assigned_user=${this.getUserMe()}&start_after=${moment(new Date()).format('YYYY-MM-DD')}
      &start_before=${moment(new Date()).format('YYYY-MM-DD')}&expand=cvtech,recruitment`

        APIRequest.get_with_request(process.env.VUE_APP_ATS_API, 'interviews', request).then(function (datas) {
          const test = datas[0].sort(function (a, b) {
            const distanceA = Math.abs(new Date() - new Date(a.start))
            const distanceB = Math.abs(new Date() - new Date(b.start))
            return distanceA - distanceB
          })
          self.actualInterview = test[0]

          datas[0] = datas[0].sort(function (a, b) {
            return new Date(a.start) - new Date(b.start)
          })
          self.interviews = datas[0]
          self.loaded = true
        })
      }
    },

    getUserMe() {
      return JSON.parse(localStorage.getItem('user_object')).uuid
    },

    goToInterview(interview) {
      this.$router.push({ name: 'cvtechprofile', params: { id: interview.cvtech.id }, query: { actualNav: 'Action' } })
    },
  },
}
</script>

<style scoped></style>
